module.exports = __webpack_public_path__ + "d259bbedd0b73f8f90c3520bbca8f71d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Sinha.png
// module id = 9At4
// module chunks = 0